import Model, { attr } from '@ember-data/model';
import { cached } from '@glimmer/tracking';

interface ICategoryRating {
  rating: number;
  tags: Record<string, number>;
}

export default class AirbnbQualityReviewAverageModel extends Model {
  @attr('object') cleanliness!: ICategoryRating;
  @attr('object') accuracy!: ICategoryRating;
  @attr('object') checkin!: ICategoryRating;
  @attr('object') location!: ICategoryRating;
  @attr('object') value!: ICategoryRating;
  @attr('object') communication!: ICategoryRating;
  @attr('number') totalReviews!: number;

  @cached
  get cleanlinessRating(): number {
    return this.cleanliness?.rating ?? 0;
  }

  @cached
  get accuracyRating(): number {
    return this.accuracy?.rating ?? 0;
  }

  @cached
  get checkinRating(): number {
    return this.checkin?.rating ?? 0;
  }

  @cached
  get locationRating(): number {
    return this.location?.rating ?? 0;
  }

  @cached
  get valueRating(): number {
    return this.value?.rating ?? 0;
  }

  @cached
  get communicationRating(): number {
    return this.communication?.rating ?? 0;
  }
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'airbnb-quality-review-average': AirbnbQualityReviewAverageModel;
  }
}
